import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { LoadingItem } from "../../../shared/components/loading";
import { AlertMsg } from "../../../shared/components/alert-msg";
import { AllProducts } from "./AllProducts";
const getStoreOrderDetails = async ({ pageProps, payload }: any) => {
    await pageProps.getStoreOrderDetails(payload);
}
export const LoadOrderInfo = ({
    pageProps,
    showOrderInfo,
    setShowOrderInfo,
    chosenOrder,
    fetchPayload,
    setOrderStatus,
    chosenOrderInfo,
    setChosenOrderInfo
}: any) => {
    let orderInfo = pageProps.getStoreOrderDetailsRequest;
    const [productList, setProductList] = useState<any[]>([]);
    const [allProductSummary, setAllProductSummary] = useState<any[]>([]);
    const [initialTotalValue, setInitialTotal] = useState<any>();
    const [isCancel, setIsCancel] = useState<boolean>(false);
    const [hideConfirmationModal, setHideConfirmationModal] =
        useState<boolean>(false);
    const [openCancelModal, setOpenCancelModal] = useState<boolean>(false);

    useEffect(() => {
        if (!setOrderStatus) {
            let payload = `OrderId=${chosenOrder?.id}`;
            getStoreOrderDetails({
                pageProps,
                payload,
            });
        }
    }, [showOrderInfo]);

    useEffect(() => {
        if (
            pageProps.getStoreOrderDetailsRequest.request_status ===
            "GET_VENDOR_ORDER_DETAILS_SUCCESS"
        ) {
            let allItems = orderInfo?.request_data?.response?.vendorProducts;
            let filteredItems = orderInfo?.request_data?.response?.vendorProducts.map(
                (eachItem: any) => ({
                    actualQuantity: eachItem?.quantity,
                    productId: eachItem?.productId,
                })
            );
            let itemsSummary = orderInfo?.request_data?.response?.vendorProducts.map(
                (eachItem: any) => ({
                    actualPrice: eachItem?.quantity * eachItem?.price,
                    productId: eachItem?.productId,
                })
            );
            let totalAmount = itemsSummary.reduce(
                (accum: any, item: any) => accum + item.actualPrice,
                0
            );
            setInitialTotal(totalAmount);
            setProductList(filteredItems);
            setAllProductSummary(itemsSummary);
        }
    }, [pageProps.getStoreOrderDetailsRequest.request_status]);


    useEffect(() => {
        if (pageProps?.changeOrderStatusRequest?.request_status ===
            "CHANGE_ORDER_STATUS_SUCCESS") {
            setShowOrderInfo(false)
        }
    }, [pageProps?.changeOrderStatusRequest?.request_status])


    return (
        <Modal
            className={`order-confirmation-modal ${hideConfirmationModal ? "visually-hidden-modal" : ""
                }`}
            show={showOrderInfo}
            onHide={() => {
                setShowOrderInfo(false);
            }}
            centered
        >
            {/* Modal Header */}
            <Modal.Header className="order-modal-header">
                <div className="header-content">
                    <div className="header-left">
                        <h4 className="modal-title">Confirm final price.</h4>
                        <p className="modal-subtitle">
                            Confirm the final subtotal price below.
                        </p>
                    </div>

                    {!setOrderStatus && (
                        <Button
                            variant="danger"
                            className="cancel-order-btn"
                            onClick={() => {
                                setHideConfirmationModal(true);
                                setOpenCancelModal(true);
                            }}
                            disabled={
                                pageProps?.getStoreOrderDetailsRequest?.request_status ===
                                "GET_VENDOR_ORDER_DETAILS_PENDING" ||
                                pageProps?.changeOrderStatusRequest?.is_request_processing ||
                                pageProps?.changeOrderStatusRequest?.request_status ===
                                "CHANGE_ORDER_STATUS_SUCCESS"
                            }
                        >
                            Cancel order
                        </Button>
                    )}

                    <button
                        className="close-button"
                        onClick={() => setShowOrderInfo(false)}
                        aria-label="Close"
                    >
                        <svg
                            width="28"
                            height="28"
                            viewBox="0 0 28 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_10887_22411)">
                                <path
                                    d="M8.22656 8.22363L19.776 19.773"
                                    stroke="#312E2E"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M8.22656 19.7744L19.776 8.225"
                                    stroke="#312E2E"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_10887_22411">
                                    <rect width="28" height="28" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                </div>
            </Modal.Header>

            {/* Modal Body */}
            <Modal.Body className="order-modal-body">
                <div className="confirm-order-body">
                    {/* Loading State */}
                    {pageProps?.getStoreOrderDetailsRequest?.request_status ===
                        "GET_VENDOR_ORDER_DETAILS_PENDING" && (
                            <div className="loading-container">
                                <LoadingItem />
                            </div>
                        )}

                    {/* Error State */}
                    {pageProps?.getStoreOrderDetailsRequest?.request_status ===
                        "GET_VENDOR_ORDER_DETAILS_FAILURE" && (
                            <div className="error-container">
                                <AlertMsg
                                    type="error"
                                    message={
                                        pageProps?.getStoreOrderDetailsRequest?.request_data?.error ||
                                        " "
                                    }
                                />
                            </div>
                        )}

                    {/* Success State */}
                    {pageProps?.getStoreOrderDetailsRequest?.request_status ===
                        "GET_VENDOR_ORDER_DETAILS_SUCCESS" && (
                            <div className="order-content">
                                <div className="all_products">
                                    {orderInfo?.request_data?.response &&
                                        productList.length >= 1 &&
                                        allProductSummary.length >= 1 && (
                                            <AllProducts
                                                pageProps={pageProps}
                                                chosenOrder={orderInfo}
                                                allProducts={orderInfo?.request_data?.response}
                                                setHideConfirmationModal={setHideConfirmationModal}
                                                setShowOrderInfo={setShowOrderInfo}
                                                productList={productList}
                                                allProductSummary={allProductSummary}
                                                initialTotalValue={initialTotalValue}
                                                setIsCancel={setIsCancel}
                                                fetchPayload={fetchPayload}
                                                setOpenCancelModal={setOpenCancelModal}
                                                openCancelModal={openCancelModal}
                                                setOrderStatus={setOrderStatus}
                                                isCancel={isCancel}
                                                chosenOrderInfo={chosenOrderInfo}
                                                setChosenOrderInfo={setChosenOrderInfo}
                                            />
                                        )}
                                </div>
                            </div>
                        )}
                </div>
            </Modal.Body>
        </Modal>
    );
};